// The R-21 channel of this bundle: `FilmstripPreviewsModule.php` prints
// `window.fotomania_filmstrip_config = { labels: { filmstrip_module: { ... } } }` as an inline script before the
// bundle's own handle. The bundle reads it once at boot; a missing or malformed value keeps the English source.
export type FilmstripConfigScope = { fotomania_filmstrip_config?: unknown };

export function readFilmstripLabels(scope: FilmstripConfigScope = globalThis as FilmstripConfigScope): unknown {
  const config = scope.fotomania_filmstrip_config;
  if (config === null || typeof config !== 'object' || Array.isArray(config)) return undefined;
  return (config as { labels?: unknown }).labels;
}
